module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image0",
    attrs: {
      "id": "ch-6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/25-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/d6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h1', {
    staticClass: "chapter-title-gr"
  }, [_vm._v("Swivel–Chair Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("Let us then approach God’s throne of grace with confidence, so that we may receive mercy and find grace to help us in our time of need.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBREWS")]), _vm._v(" 4:16")]), _vm._v(" "), _c('p', {
    staticClass: "line-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })])]), _c('p', {
    staticClass: "d-para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "brwn"
  }, [_vm._v("D")])]), _vm._v("r. Andrew Farley, speaker and teacher of all things real freedom, explains many believers’ faulty understanding of God’s judgment of them. Pastor Farley asks if the listener believes in a swivel-chair Jesus—where Jesus is turned toward us when we are “good” and away from us when we are “bad.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/107_Endnotes#end-1",
      "id": "end_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This concept has stuck with me. This spinning is exactly what I believed Jesus did. Monitoring and keeping a running record of my good and bad deeds. Say we took in a foster placement, check! He’s facing toward me. But when we turned away a foster placement because we were sick with the flu, the Jesus of my mind and beliefs swung his chair away from me, too disgusted to gaze upon me with his divine eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/25-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beloved, that is not the seat of the Christ. There is no separation we can fabricate to keep us from the love "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("and care of God. You cannot earn his favor—it was already bought and paid for. Were you to have to pay back the work of the cross, it would no longer be a sacrifice—it would be a purchase. If you were to try to earn it with your good deeds and ninja volunteer moves, it would become a wage. And you are not strong enough, good enough, or wealthy enough to pay the price to gain God’s love.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The promises of Jesus are true. You are seen, heard, and known. You were not created to be in a heap of stress and terror. You were created in the image of God (Genesis 1:27).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Furthermore, God tells us to ask for the things he’s promised and then believe as if we have received it, and it will be given to us (Mark 11:24).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So what is the problem?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Our past experiences are the problem. Our brains remember and react to hard or dangerous scenarios, and if you’ve had your share of them, or like me just have a fantastic imagination, your brain is spring-loaded to release stress chemicals and fear-based responses, which bounce around in the same space. Then your self-talk ends up sounding like this: “You should worry about this, but you really should have more faith in Jesus. Also, this seems like it is really, really awful. And … Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I know it may sound too good to be true that we don’t have to feel this way. But hold on—you’ll soon see that the fulfillment of God’s promises is plausible "), _c('em', [_vm._v("and")]), _vm._v(" that it’s possible to think, speak, and live in the promised freedom. We can find grace in our time of need.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The tiresome, costly worry-work is the incompleteness of religion. Grace, which makes no logical sense and makes no apologies for the claim it holds over you, is free. The chair that Jesus sits on needs no swivel bar ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("or wheels. He doesn’t need a desk pad to protect the streets of gold. He is comfortably seated with nothing but love as his measuring stick, which has no beginning and no end.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Today consider your religion (as opposed to your faith). Consider what is required of you in religion versus what you experience in the intimacy of relationship with Jesus. Ask yourself, How would Jesus meet with me in this moment? Would he be sitting formally behind a desk, a scowl upon his face? Probably not. You have a sit-on-the-floor kind of relationship with him. When you compare what you think God requires with what he actually asks for, you’ll see that certain beliefs about what is expected of you came from man. What Jesus offers is in the heavenlies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He will never turn from you in disappointment. If there are rollers on his chair, he only pulls himself nearer to you in a swift and easy motion. Nothing … no, nothing can separate you from him (Romans 8:35–39). He will not accuse you or ever turn away from you. There’s no beginning, no end to love just as there is no beginning or end to him.")]), _vm._v(" "), _c('div', {
    staticClass: "box-o"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_c('strong', [_vm._v("THE FINISHING TOUCH")])]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Lord, thank you for wisdom and understanding. Thank you for your protective care and for never turning from me. I trust and I believe you. Amen.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790e5ec4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013_Chapter06.vue
// module id = 93
// module chunks = 0